<template>
  <div class="shopping-cart-wrap">
    <header-title title="购物车">
      <div slot="right">
        <div class="clear" @click="del({}, 'all')">清除失效报价</div>
      </div>
    </header-title>
    <div class="table-wrapper">
      <el-table :data="tableData" v-loading="loading" :row-class-name="tableRowClassName">
        <el-table-column label="卖家" prop="userName" />
        <el-table-column label="升贴水单价" prop="liftingWater" />
        <el-table-column label="品牌" prop="brandName" />
        <el-table-column label="等级" prop="grade" />
        <el-table-column label="榨季" prop="season" />
        <el-table-column label="交货地" prop="addressStr" />
        <el-table-column label="剩余数量(吨)" prop="saleableQuantity" />
        <el-table-column label="可交货日期" prop="deliveryDate">
          <template slot-scope="scope">
            {{ scope.row.deliveryDate ? scope.row.deliveryDate.substr(0,10) : '' }}
          </template>
        </el-table-column>
        <el-table-column label="定价购销计划" prop="contract" />
        <el-table-column label="状态" prop="contangoStatus">
          <template slot-scope="scope">
            {{ scope.row.contangoStatus === '40' ? '已下架' : '销售中' }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="operate-button" @click="placeOrder(scope.row)" v-if="scope.row.contangoStatus === '30'">下单</div>
            <div class="operate-button red-button" @click="del(scope.row, 'one')">移除</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrapper">
        <pagination @retrieve="retrieve" :data="pageData" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShoppingCart',
  data () {
    return {
      tableData: [], // 表格数据
      pageData: {}, // 表格分页数据
      pageSize: 20, // 表格一页数据数量
      currentNo: 1, // 当前页
      loading: false, // 表格加载loading
    }
  },
  methods: {
    // 获取表格数据
    retrieve (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.loading = true
      this.currentNo = currentNo || this.currentNo || 1
      const url = this.$API.shoppingCart.retrieve
      const param = {
        currentNo: this.currentNo,
        pageSize: this.pageSize,
      }
      this.$http.post(url, param).then(res => {
        this.tableData = res.data.rows
        this.pageData = res.data
        this.loading = false
      }).catch(() => {
        this.tableData = []
        this.pageData = {}
        this.loading = false
      })
    },
    // 控制表格行类名
    tableRowClassName ({ row }) {
      if (row.contangoStatus === '40') { // 已下架的列搞一个特殊样式
        return 'cancel_row'
      }
    },
    // 跳转下单页
    placeOrder (row) {
      this.$router.push({ path: `/framework/home/placeTheOrder/${row.id}` })
    },
    // 移除报价, type=‘all’是清除所有失效报价，‘one’是清除单条报价
    del (row, type) {
      const url = type === 'all' ? this.$API.shoppingCart.cancelOffContango : this.$API.shoppingCart.cancelCollect
      const tip = type === 'all' ? '您确定要清除所有失效报价吗？' : '您确定要将本条记录从列表中移除吗？'
      const param = {
        id: row.id
      }
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http.post(url, param).then(() => {
            this.$message.success('操作成功')
            if (type === 'all') { // 清除全部的时候，表格数量会有变化，所以回到第一页刷新
              this.retrieve(1)
            } else {
              this.retrieve(this.currentNo)
            }
          })
        })
        .catch(() => {})
    },
  }

}
</script>

<style lang="scss" scoped>
  .shopping-cart-wrap{
    .clear{
      font-size: 14px;
      color: rgba(51,51,51,0.94);
      cursor: pointer;
    }
    /deep/ .cancel_row{
      td{
        background: #fbfbfb !important;
        .cell{
          color: rgba(153,153,153,0.94) !important;
        }
      }
    }
  }
</style>
